class KPIWidget extends BaseWidget<KPIWidgetResultVM, KPIConfig> {
    override widgetType = WidgetType.KPI;

    constructor(container: any, tab: WorkbookTab, $reportContent, dashboardWidget: DashboardWidget) {
        super(container, tab, $reportContent, dashboardWidget);
        this.disableDrilldown = true;
    }

    setConfig(config) {
        this.itemConfig = new KPIConfig(config);
    }

    setResult(result) {
        this.result = new KPIWidgetResultVM(result, this.itemConfig);
    }

    setupSettings() {
        this.createSettingItem(this.itemConfig.indicatorMetric, "indicatorMetric", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.targetMetric, "targetMetric", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.trendAxisField, "trendAxisField", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.trendAxisFieldAutoGrouping, "trendAxisFieldAutoGrouping", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.showTrendAxis, "showTrendAxis", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.trendAxisHeight, "trendAxisHeight", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.decimalPlaces, "decimalPlaces", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.format, "format", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.accountingStyle, "accountingStyle", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.showLargeNumber, "showLargeNumber", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.indicatorFontSize, "indicatorFontSize", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.indicatorFontColor, "indicatorFontColor", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.indicatorFontBold, "indicatorFontBold", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.indicatorFontItalic, "indicatorFontItalic", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleText, "titleText", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.targetText, "targetText", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.showDistanceFromTarget, "showDistanceFromTarget", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.distanceType, "distanceType", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.backgroundColor, "backgroundColor", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.formattingRule, "formattingRule", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.useLastPeriod, "useLastPeriod", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.showIcon, "showIcon", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.iconSize, "iconSize", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.tabDetailOrderByField, "tabDetailOrderByField", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.tabDetailOrderByDirection, "tabDetailOrderByDirection", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.filterZeros, "filterZeros", UpdateSettingMode.Reload);

        this.createSettingItem(this.itemConfig.comparisonFilter.dateOption, "comparisonFilter.dateOption", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.comparisonFilter.dateRange, "comparisonFilter.dateRange", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.comparisonFilter.dateUnit, "comparisonFilter.dateUnit", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.comparisonFilter.dateUnitValue, "comparisonFilter.dateUnitValue", UpdateSettingMode.Reload);

        this.createSettingItem(this.itemConfig.titleTextConfig.show, "titleTextConfig.show", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.alignment, "titleTextConfig.alignment", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.backgroundColor, "titleTextConfig.backgroundColor", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.fontColor, "titleTextConfig.fontColor", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.fontBold, "titleTextConfig.fontBold", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.fontItalic, "titleTextConfig.fontItalic", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.show, "titleTextConfig.show", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.titleTextConfig.show, "titleTextConfig.show", UpdateSettingMode.Automatic);

        this.createSettingItem(this.itemConfig.targetTextConfig.fontBold, "targetTextConfig.fontBold", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.targetTextConfig.fontItalic, "targetTextConfig.fontItalic", UpdateSettingMode.Automatic);
    }

    repaint() {

    }

    runSetup() {

    }

    setup() {
        this.setupKPI(this.$reportContent, this.result);
    }

    setupKPI(dashboardWidget, vm: KPIWidgetResultVM) {
        let self = this;

        //new ResizeObserver(function (e, resizeObserver) {
        //    //if element still in DOM
        //    if ($(e[0].target).parents('html').length > 0) {
        //        let sparkLine = $(".widget-kpi-sparkline", dashboardWidget).dxSparkline("instance");
        //        if (sparkLine)
        //            sparkLine.render();
        //    }
        //    else
        //        resizeObserver.unobserve(e[0].target)
        //}).observe($(".widget-result", dashboardWidget)[0]);
    }
    
}